import type { GlobalAnimationConfig } from './types';

export enum AnimationKeys {
  SAFE_OPEN = 'safe_open',
  SAFE_CLOSE = 'safe_close',
  SAFE_LOCKED = 'safe_locked',
  SAFE_OPEN_KEEP = 'safe_open_keep',
  SAFE_OPEN_CLAIM = 'safe_open_claim',
  SAFE_CLOSE_CLAIM = 'safe_close_claim',
}

export type AnimationConfig = Record<AnimationKeys, GlobalAnimationConfig>;

export const MAX_ANIMATION_BLOCK_SCREEN_DURATION = 10000;
